
import React, { Component } from "react";
import { Alert, Button, Col, Container, Label, Row } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// action
import { forgetUser, resetForgetPWState, resetLoginState } from '../../store/actions';

// import images
import { InputAdornment, Stack, TextField } from "@mui/material";
import logodark from "../../assets/images/cvs-logo.png";
import withRouter from "../../components/Common/withRouter";

class ForgetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.props.resetLoginState()
        this.props.resetForgetPWState()
        this.state = {
            email: "",
        };

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    }

    // handleValidSubmit
    handleValidSubmit(event) {
        this.props.resetForgetPWState()
        const values = {
            email: this.state.username,
        }
        this.props.forgetUser(values, this.props.history);
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <Container fluid className="p-0">
                        <Row className="g-0">
                            <Col lg={4}>
                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Row className="justify-content-center">
                                            <Col lg={9}>
                                                <div>
                                                    <div className="text-center">
                                                        <div>
                                                            <Link to="/" className="logo"><img src={logodark} height="70" alt="logo" /></Link>
                                                        </div>

                                                        <h4 className="font-size-18 mt-4">Reset Password</h4>
                                                        <p className="text-muted">Reset your password.</p>
                                                    </div>
                                                    <div className="p-2 mt-5">
                                                        {this.props.forgetError && this.props.forgetError ?
                                                            <Alert color="danger" className="mb-4">{this.props.forgetError}</Alert> : null}{
                                                            this.props.message && this.props.message?.message ?
                                                                <Alert color="success" className="mb-4">{this.props.message?.message === "Email has been sent" && "Email has been sent, please check"}</Alert> : null
                                                        }

                                                        <Stack flexDirection="column">
                                                            <Label htmlFor="username">Email</Label>
                                                            <TextField
                                                                required
                                                                value={this.state.username}
                                                                variant="outlined"
                                                                onChange={(e) => this.setState({ username: e.target.value })}
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start" className='auth-icon'><i className="ri-user-2-line auti-custom-input?-icon"></i></InputAdornment>,
                                                                }}
                                                            />
                                                        </Stack>
                                                        <div className="mt-4 text-center">
                                                            <Button color="primary-button" className="w-md waves-effect waves-light" type="submit" disabled={this.props.loading}  onClick={(e) => this.handleValidSubmit(e)}>{this.props.loading ? "Loading..." : "Reset"}</Button>
                                                        </div>
                                                        <div className="mt-4 text-center">
                                                            <Link to="/login" className="text-muted"><i className="mdi mdi-lock me-1"></i> Go Back to Sign In</Link>
                                                        </div>
                                                    </div>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8}>
                                <div className="authentication-bg">
                                    <div className="bg-overlay"></div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { message, forgetError, loading } = state.Forget;
    return { message, forgetError, loading };
}

export default withRouter(
    connect(mapStatetoProps, { forgetUser, resetLoginState, resetForgetPWState })(ForgetPasswordPage)
);
